import React from 'react'
import { Box, Button, Paper, Stack, Typography } from '@mui/material'
import { dismissEntryDetails, skipDeferredDetails } from './engine'
import { fmtTime, logKeyForEvent, requestForPending, toneOf } from './liveUi'

export const pendingTitle = (item) =>
  item.entry?.moduleName || item.form?.title || item.action?.label || 'Details'

export const pendingSubtitle = (item) =>
  [
    item.entry?.['Medicine Name'] &&
      [item.entry['Medicine Name'], item.entry.Dose].filter(Boolean).join(' '),
    !item.entry?.['Medicine Name'] && item.event?.detail,
  ]
    .filter(Boolean)
    .join(' · ')

// Updater that dismisses one pending item (entry stub or deferred prompt)
export const dismissPending = (item) => (record) => {
  if (item.entry?.entryId) {
    return dismissEntryDetails(record, item.section, item.entry.entryId)
  }
  if (item.event?.id) {
    const logKey = logKeyForEvent(record, item.event.id)
    return logKey ? skipDeferredDetails(record, logKey, item.event.id) : record
  }
  return record
}

// "To complete" list: everything tapped on a console still waiting for its
// detail form. onOpen(request) opens LiveDetailForm.
const PendingDetailsList = ({ items, onOpen, onDismiss, emptyText }) => {
  if (!items.length) {
    return (
      <Typography color="text.secondary" sx={{ p: 1 }}>
        {emptyText ?? 'Nothing waiting for details.'}
      </Typography>
    )
  }
  return (
    <Stack gap={1}>
      {items.map((item) => {
        const tone = toneOf(item.action?.tone)
        const time =
          item.event?.time || item.entry?.dateTime || item.entry?.time
        const key = item.entry?.entryId || item.event?.id
        const subtitle = pendingSubtitle(item)
        return (
          <Paper
            key={key}
            variant="outlined"
            sx={{ p: 1.25, borderLeft: 6, borderLeftColor: tone.main }}
          >
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              gap={1}
              alignItems={{ xs: 'stretch', sm: 'center' }}
            >
              <Box flex={1} minWidth={0}>
                <Typography fontWeight={700}>{pendingTitle(item)}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {[fmtTime(time), subtitle].filter(Boolean).join(' · ')}
                </Typography>
              </Box>
              <Stack direction="row" gap={1}>
                {item.form && (
                  <Button
                    variant="contained"
                    onClick={() => onOpen(requestForPending(item))}
                    sx={{ minHeight: 44, flex: { xs: 1, sm: 'none' } }}
                  >
                    Add details
                  </Button>
                )}
                {onDismiss && (
                  <Button
                    color="inherit"
                    onClick={() => onDismiss(item)}
                    sx={{ minHeight: 44 }}
                  >
                    Not needed
                  </Button>
                )}
              </Stack>
            </Stack>
          </Paper>
        )
      })}
    </Stack>
  )
}

export default PendingDetailsList
